var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 419,
    height: 78,
    viewBox: "0 0 419 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M394.564 63.7544H366.073L361.505 77.2388H342.04L369.661 0.899994H391.193L418.814 77.2388H399.131L394.564 63.7544ZM389.779 49.4001L380.318 21.4527L370.966 49.4001H389.779Z",
    fill: "#2E9FFF",
    fillOpacity: 0.913725
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M288.638 0.899994V46.5728C288.638 51.1401 289.762 54.6561 292.009 57.121C294.257 59.5859 297.555 60.8183 301.905 60.8183C306.255 60.8183 309.59 59.5859 311.909 57.121C314.229 54.6561 315.389 51.1401 315.389 46.5728V0.899994H333.985V46.464C333.985 53.2787 332.535 59.0422 329.635 63.7544C326.735 68.4667 322.82 72.0191 317.89 74.4114C313.033 76.8038 307.596 78 301.579 78C295.561 78 290.16 76.8401 285.376 74.5202C280.663 72.1278 276.93 68.5755 274.175 63.8632C271.42 59.0784 270.043 53.2787 270.043 46.464V0.899994H288.638Z",
    fill: "#2E9FFF",
    fillOpacity: 0.913725
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M237.141 62.8845H261.499V77.2388H218.545V0.899994H237.141V62.8845Z",
    fill: "#2E9FFF",
    fillOpacity: 0.913725
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M185.889 63.7544H157.398L152.83 77.2388H133.365L160.986 0.899994H182.518L210.139 77.2388H190.456L185.889 63.7544ZM181.104 49.4001L171.643 21.4527L162.291 49.4001H181.104Z",
    fill: "#2E9FFF",
    fillOpacity: 0.913725
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M130.595 0.899994L103.518 77.2388H80.2466L53.1692 0.899994H72.9607L91.8823 58.5347L110.913 0.899994H130.595Z",
    fill: "#2E9FFF",
    fillOpacity: 0.913725
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6953 15.798V31.2398H43.5979V45.5941H18.6953V62.3408H46.8602V77.2388H0.0999756V0.899994H46.8602V15.798H18.6953Z",
    fill: "#2E9FFF",
    fillOpacity: 0.913725
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.f755b9f584e00f74e187b22b1bf97cfe.svg";
export { ForwardRef as ReactComponent };